export const site = {
  name: "深瞳档案",
  slogan: "深扒幕后 · 内幕合集 · 真相速递",
  intro:
    "深瞳档案是一个专注幕后内幕与隐秘事件深度整理的内容档案站。我们不追逐热度，而是把事件背后的时间线、关联方与相关信息重新梳理清楚，让读者自己看清事件的深层逻辑。",
  email: "contact@shentongdangan.cn",
  workingHours: "周一至周五 10:00 - 18:00",
  updatedAt: "2026-09-12",
  nav: [
    { label: "首页", path: "/" },
    { label: "栏目总览", path: "/channels" },
    { label: "关于我们", path: "/about" },
    { label: "常见问题", path: "/faq" },
    { label: "联系我们", path: "/contact" },
  ],
};